import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../../services/dashboard.service';
import {BillingFiltersFactory} from "../../shared/factories/billing-letters/filters.factory";
import {UrlBuilderFactory} from "../../shared/factories/url-builder.factory";
import * as _ from 'lodash';
import {CommonHelper} from "../../shared/helpers/CommonHelper";
import { LocalStorage } from '../../shared/wrappers/LocalStorage';
import { Route } from 'aws-sdk/clients/ec2';
import { ActivatedRoute } from '@angular/router';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
    data:any;
    loading:boolean;
    public consultantLabel = [];
    public consultantHoverLabel = [];
    public consultantData:number[] = [];
    consultantTotal:number=0;
    public ApprovalLabel = [];
    public ApprovalHoverLabel = [];
    public ApprovalData:number[] = [];
    approvalTotal:number =0;
    public LetterDiviLabel= [];
    public LetterDiviHoverLabel= [];
    public LetterDiviData:number[] = [];
    LetterDivTotal:number =0;
    public LetterStatusLabel = [];
    public LetterStatusHoverLabel = [];
    public LetterStatusData:number[] = [];
    letterStatusTotal:number =0;
    public LetterValueLabel = [];
    public LetterValueHoverLabel = [];
    public LetterValueData:number[] = [];
    letterValueTotal:number=0;
    public ApprovalValueLabel = [];
    public ApprovalValueHoverLabel = [];
    public ApprovalValueData:number[] = [];
    approvalValueTotal:number=0;
    public chartColors: any[] = [
        {
            backgroundColor:['#3566ca', '#990697', '#09951d', '#fe980f', '#db3813','#f0c93e','magenta','gray','pink','black']
        }
    ];

    month = new Date().getMonth();
    year = new Date().getFullYear();
    monthList;
    yearList;

    public doughnutChartType:string = 'doughnut';
    public lineChartOptions:any = {
        maintainAspectRatio: false,
        legend: { display: false } };

  constructor(private DashboardService:DashboardService,
              private billingFiltersFactory: BillingFiltersFactory,
              private queryStringFactory: UrlBuilderFactory,
              private CommonHelper:CommonHelper,
              private localStorage:LocalStorage,
              private route:ActivatedRoute,
              private userService: UserService) { }

    async ngOnInit() {

    this.loading=true;
    let token = this.route.snapshot.params['token']?this.route.snapshot.params['token']:null;
    if(token){
        token = JSON.parse(window.atob(token));
        let username = token.unique_name;
        let user = this.userService.getUserByUsername(username);
        this.localStorage.persist('user',user);
    }
    this.monthList = this.CommonHelper.listAllMonths();
    this.yearList = this.CommonHelper.listLastYears();
    await this.search();
    this.loading=false;

  }

    setConsultant(data){
      this.consultantTotal = 0;
      data.consultants.map((item,index)=>{
          this.consultantTotal += item.count;
          this.consultantData.push(item.count);
          this.consultantLabel.push({label:item._id, color:this.chartColors[0].backgroundColor[index],data:this.consultantData[index].toFixed(2)});
          this.consultantHoverLabel.push(item._id);

      });
    }

    setApprovals(data){
        this.approvalTotal = 0;
        data.approvals.map((item,index)=>{
            this.approvalTotal += item.count;
            this.ApprovalData.push(item.count);
            this.ApprovalLabel.push({label:item._id, color:this.chartColors[0].backgroundColor[index],data:this.ApprovalData[index].toFixed(2)});
            this.ApprovalHoverLabel.push(item._id);

        });
    }

    setApprovalsValue(data){
        this.approvalValueTotal = 0;
        data.approvalValue.map((item,index)=>{
            this.approvalValueTotal += item.count;
            this.ApprovalValueData.push(item.count.toFixed(2));
            this.ApprovalValueLabel.push({label:item._id, color:this.chartColors[0].backgroundColor[index],data:this.ApprovalValueData[index]});
            this.ApprovalValueHoverLabel.push(item._id);


        });
    }

    setLetterValue(data){
        this.letterValueTotal = 0;
        data.letterValue.map((item,index)=>{
            this.letterValueTotal += item.totalValue;
            this.LetterValueData.push(item.totalValue);
            this.LetterValueLabel.push({label:item._id, color:this.chartColors[0].backgroundColor[index],data:this.LetterValueData[index].toFixed(2)});
            this.LetterValueHoverLabel.push(item._id);

        });
    }


    setLetterStat(data){
        this.letterStatusTotal = 0;
        data.letterStatus.map((item,index)=>{
            this.letterStatusTotal += item.count;
            this.LetterStatusData.push(item.count);
            this.LetterStatusLabel.push({label:item._id, color:this.chartColors[0].backgroundColor[index],data:this.LetterStatusData[index].toFixed(2)});
            this.LetterStatusHoverLabel.push(item._id);
        });
    }


    public chartClicked(e:any):void {
        console.log(e);
    }

    public chartHovered(e:any):void {
        console.log(e);
    }

    async search(){
        this.clean();
        this.data = await this.DashboardService.getData(this.year, this.month);
        this.setConsultant(this.data);
        this.setApprovals(this.data);
        this.setLetterStat(this.data);
        this.setApprovalsValue(this.data);
        this.setLetterValue(this.data);
    }
    clean(){
        this.consultantLabel = [];
        this.consultantHoverLabel = [];
        this.consultantData= [];
        this.ApprovalLabel = [];
        this.ApprovalHoverLabel = [];
        this.ApprovalData = [];
        this.LetterDiviLabel= [];
        this.LetterDiviHoverLabel= [];
        this.LetterDiviData = [];
        this.LetterStatusLabel = [];
        this.LetterStatusHoverLabel = [];
        this.LetterStatusData = [];
        this.LetterValueLabel = [];
        this.LetterValueHoverLabel = [];
        this.LetterValueData = [];
        this.ApprovalValueLabel = [];
        this.ApprovalValueHoverLabel = [];
        this.ApprovalValueData = [];
    }


}



// WEBPACK FOOTER //
// ./src/app/views/dashboard/dashboard.component.ts